import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    color: #fff;
    background: #010606;

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }
`
const Wrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 600px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
    @media screen and (max-width: 768px){
        height: 800px;
    }
`
const Row = styled.div`
    display:grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: 'col2 col1';

    @media screen and (max-width: 768px){
        grid-template-areas: 'col2' 'col1';
    }
`
const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`
const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`
const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`
const TopLine = styled.div`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`
const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 46px;
    line-height: 1.1;
    font-weight: 500;
    color: #f7f8fa;

    @media screen and (max-width: 600px) {
        font-size: 32px;
    }
`
const Subtitle = styled.div`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: #fff;
`
const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`
const Btn = styled.div`
    border-radius: 50px;
    background: #fff;
    color: #000;
    white-space: nowrap;
    padding: 14px 48px;
    font-size: 20px;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background : #cebfff;
        color: #000
    }

    @media screen and (max-width:786px){
        padding: 12px 30px;
        font-size: 16px;
    }
`

const Services = () => {
    return(
        <Container id='services'>          
            <Wrapper>
                <Row>
                    <Column1>
                    <TextWrapper>
                    <TopLine>Services</TopLine>
                    <Heading>What I’ve Worked on</Heading>
                    <Subtitle>Worked with API's and databases to make it easier for users to get certain information using different languages, platforms, frameworks such as JavaScript, React, Next, Node, Heroku and Netlify </Subtitle>
                            <BtnWrap>
                            <a style={{textDecoration: "none",color:"#000"}} href='/resume.pdf' rel="noreferrer" target='_blank'>
                                <Btn>Full Resume</Btn>
                            </a>
                            </BtnWrap>
                    </TextWrapper>
                    </Column1>
                    <Column2>
                    <TextWrapper>
                    <br/><br/>
                    <Heading>Skills</Heading>
                    <Subtitle>
                    - HTML, CSS, JavaScript, Bootstrap. <br/><br/>
                    - JavaScript Frameworks (React, Next, Node). <br/><br/>
                    - Responsive , Testing and Debugging. <br/><br/>
                    - Website Deployment and Hosting . <br/><br/>
                    - UI design and UX design. <br/><br/>
                    - Version Control System. 
                    </Subtitle>
                    </TextWrapper>
                    </Column2>
                </Row>
                
            </Wrapper>
        </Container>
    )
}

export default Services